'use client';

import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer>
      <div className="footer-content">
        <div>
          <Link to="/" className="logo footer-logo font-serif text-3xl font-extrabold text-yellow-500 flex items-center">
            <div className="logo-icon font-serif text-[2rem] font-extrabold text-yellow-500">W</div>
            WizardPortrait
          </Link>
          <p className="footer-about" style={{marginTop: '1rem'}}>Bringing the magic of wizarding portraits to the muggle world since 2025. WizardPortrait combines cutting-edge AI technology with the wonder of living art.</p>
          <div className="footer-social">
            
            <a href="https://www.tiktok.com/@wizard.portrait" className="social-icon">tk</a>
            <a href="https://www.instagram.com/wizard.portrait/" className="social-icon">ig</a>
          </div>
        </div>
        
        <div>
          <h4 className="footer-title">Company</h4>
          <ul className="footer-links">
            <li className="footer-link"><Link to="/info/about">About Us</Link></li>
            <li className="footer-link"><Link to="/info/team">Our Team</Link></li>
            <li className="footer-link"><Link to="/info/careers">Careers</Link></li>
            <li className="footer-link"><Link to="/info/press">Press</Link></li>
          </ul>
        </div>
        
        <div>
          <h4 className="footer-title">Support</h4>
          <ul className="footer-links">
            <li className="footer-link"><Link to="/info/help">Help Center</Link></li>
            <li className="footer-link"><Link to="/info/contact">Contact Us</Link></li>
            <li className="footer-link"><Link to="/info/faq">FAQ</Link></li>
            <li className="footer-link"><Link to="/info/community">Community</Link></li>
          </ul>
        </div>
        
        <div>
          <h4 className="footer-title">Legal</h4>
          <ul className="footer-links">
            <li className="footer-link"><Link to="/info/terms">Terms of Service</Link></li>
            <li className="footer-link"><Link to="/info/privacy">Privacy Policy</Link></li>
            <li className="footer-link"><Link to="/info/cookie">Cookie Policy</Link></li>
            <li className="footer-link"><Link to="/info/shipping">Shipping Policy</Link></li>
          </ul>
        </div>
      </div>
      
      <p className="copyright">© 2025 WizardPortrait. No actual magic involved, but we&apos;re pretty close.</p>

      <style jsx>{`
        footer {
          background:rgb(3, 3, 4);
          padding: 4rem 2rem 2rem;
          color: var(--text-light);
          cursor: default;
        }
        
        .footer-content {
          max-width: 1200px;
          margin: 0 auto;
          display: grid;
          grid-template-columns: 2fr 1fr 1fr 1fr;
          gap: 3rem;
        }
        
        .logo {
          font-family: 'Montserrat', sans-serif;
          font-size: 1.2rem;
          font-weight: 200;
          color: var(--accent);
          text-decoration: none;
          display: flex;
          align-items: center;
          margin-bottom: 1.5rem;
        }
        
        .logo-icon {
          width: 40px;
          height: 40px;
          margin-right: 10px;
          border: 1px solid white;
          display: flex;
          align-items: center;
          justify-content: center;
          
        }
        
        .footer-logo {
          margin-bottom: 1.5rem;
        }
        
        .footer-about {
          margin-bottom: 2rem;
          opacity: 0.7;
          line-height: 1.6;
        }
        
        .footer-social {
          display: flex;
          gap: 1rem;
        }
        
        .social-icon {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.05);
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.2rem;
          transition: var(--transition);
          text-decoration: none;
          color: var(--light);
        }
        
        .social-icon:hover {
          background: var(--accent);
          color: var(--text-dark);
          transform: translateY(-3px);
        }
        
        .footer-title {
          font-size: 1.2rem;
          margin-bottom: 1.5rem;
          color: white;
          font-family: serif;
        }
        
        .footer-links {
          list-style: none;
          padding: 0;
        }
        
        .footer-link {
          margin-bottom: 0.8rem;
        }
        
        .footer-link a {
          color: var(--text-light);
          text-decoration: none;
          opacity: 0.7;
          transition: var(--transition);
        }
        
        .footer-link a:hover {
          opacity: 1;
          color: var(--accent);
          padding-left: 5px;
        }
        
        .copyright {
          text-align: center;
          padding-top: 3rem;
          opacity: 0.5;
          font-size: 0.9rem;
        }
        
        @media (max-width: 992px) {
          .footer-content {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
    </footer>
  );
} 